import { all } from "redux-saga/effects"
import handleAddToMatchMakingPool from "./handleAddToMatchMakingPool"
import handleRemoveFromMatchmakingPool from "./handleRemoveFromMatchmakingPool"

export default function* () {
  yield all([handleAddToMatchMakingPool, handleRemoveFromMatchmakingPool])
}
